export class DetalleDteImpuestoAdicional {
   detalleDteId: string;
   nroImp: number;
   codigoSii: number;
   nombreImp: string;
   valor: number;
   tasa: number;
   impuestoIdRelated: number;
}
